import React, { ReactNode, createContext, useState } from 'react';
import SiTrackSnackbar from '../components/si-track-snackbar';

interface createContextProps {
  showSnackbar: (message: string, severity: 'info' | 'warning' | 'error' | 'success') => any;
}

interface SnackbarProviderProps {
  children: ReactNode;
}

export const SnackbarContext = createContext<createContextProps>({
  showSnackbar: (message: string, severity: 'info' | 'warning' | 'error' | 'success') => {
    console.log(message, severity);
  },
});

export const SnackbarProvider = ({ children }: SnackbarProviderProps) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('info');

  const showSnackbar = (message: string, severity = 'info') => {
    setMessage(message);
    setSeverity(severity);
    setOpen(true);
  };

  const hideSnackbar = () => {
    setOpen(false);
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <SiTrackSnackbar open={open} onClose={hideSnackbar} message={message} severity={severity} />
    </SnackbarContext.Provider>
  );
};
